import { defineStore } from 'pinia'
import UserState, { UserStateType } from './state'
import { UserActions, UserActionsType } from './actions'
import { UserGetters } from './getters'

export const useUserStore = defineStore<'user', UserStateType, typeof UserGetters, UserActionsType>(
  'user',
  {
    state: UserState,
    actions: UserActions,
    getters: UserGetters,
  },
)
